<template>
    <div class="section">
        <div class="columns is-multiline is-centered">
            <div class="column is-full has-text-centered">
                <h1 class="title is-size-3">Ponete en contacto</h1>
            </div>
            <div v-if="!loggedUser" class="column is-half">
                <b-field label="Email">
                    <b-input
                    v-model="message.email"
                    icon="envelope"
                    required>
                    </b-input>
                </b-field>
                <b-field label="Numero de telefono">
                    <b-input
                    v-model="message.phoneNumber"
                    required
                    ></b-input>
                </b-field>
            </div>
            <div class="column is-half">
                <b-field label="Asunto">
                    <b-input
                    v-model="message.title"
                    required>
                    </b-input>
                </b-field>
                <b-field label="Mensaje">
                    <b-input
                    required
                    v-model="message.message"
                    maxlength="400"
                    type="textarea">
                    </b-input>
                </b-field>
                <b-field>
                    <VueRecaptcha @verify="verifyCaptcha" sitekey="6LcHavwUAAAAAGnN37OSgSLR7e9XfivBHo7xGRwd"/>
                </b-field>
            </div>
            <div class="column is-full has-text-centered">
                <b-button
                class="is-custom"
                :disabled="disabledBtn"
                :loading="loading"
                rounded
                @click="sendMessage">
                    Enviar mensaje
                    <b-icon icon="paper-plane" size="is-small" class="m-r-5"></b-icon>
                </b-button>
            </div>
        </div>

    </div>
</template>

<script>
import { postHandler } from '../../../services/http'
import VueRecaptcha from "vue-recaptcha";

export default {
    components:{
        VueRecaptcha
    },
    props:{
        endpoint:{
            type:String,
            default:""
        },
        authUser:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            message:{},
            loading:false,
            captchaToken:""
        }
    },
    methods:{
        async sendMessage(){
            var error = {
                resource:"toast",
                text:"Verifica que estan los datos requeridos ingresados y que validaste el captcha"
            }
            var success = {
                resource:"toast",
                text:"Mensaje enviado con exito!!"
            }
            this.loading=true
            this.message["captchaToken"] = this.captchaToken
            var resp = await postHandler(this.endpoint, this.message, {error, success}) 
            this.loading=false
            this.message = {}
            grecaptcha.reset()
        },
        verifyCaptcha(token){
            this.captchaToken=token
            this.disabledBtn
        }
    },
    computed:{
        loggedUser(){
            return this.authUser == "True"
        },
        
        disabledBtn(){
            var boolVal = false
            var boolVal2;
            if (!this.loggedUser){
                boolVal = !this.message.email || !this.message.phoneNumber 
            }

            boolVal2 = !this.message.title || !this.message.message 
            var value = boolVal || boolVal2 || !this.captchaToken
            return value
        }
    },

}

</script>

<style lang="scss" scoped>


.is-custom{
    background:var(--primary);
    color:var(--text-color)
}

</style>